module.exports = __webpack_public_path__ + "static/media/third_declension0_img.c3e2303e.JPG";